"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const dryscalphair = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-dryscalphair` : '') + (description ? ` desc-dryscalphair` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-dryscalphair"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-dryscalphair"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.24 12.04a.6.6 0 0 1 .43.18l.18.91c.01.45.1.87.23 1.27l1.26 6.64H1.21l4.4-9h1.63Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.91 21.04h-5.3l1.05-6.85c.1-.36.17-.74.18-1.14l.11-.76a.6.6 0 0 1 .49-.25h2.22l1.25 9Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M22.84 12.04c.33 0 .6.27.6.6v7.8a.6.6 0 0 1-.6.6h-.41l-1.26-9h1.67Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.1 21h-3.24l-.8-4.18a4.48 4.48 0 0 0 4.7-.09l-.66 4.28Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M.64 18.79v-6.15c0-.33.27-.6.6-.6h2.7l-3.3 6.75Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.57 2.56a.4.4 0 0 1 .31.1c.18.17.15.41.04.58-.68 1-1.8 2.76-2.22 4.17-.26.9-.46 1.93-.56 2.81a8.4 8.4 0 0 0-.06 1.17c.02.33.06.55.11.65.16.32.37.71.54 1.13.18.42.31.89.31 1.39 0 .5-.16.97-.48 1.31-.31.35-.76.55-1.3.55-.49 0-1-.11-1.39-.44-.4-.34-.63-.86-.63-1.59 0-.6.23-1.18.44-1.6a5.7 5.7 0 0 1 .39-.64l.01-.12.11-.66c.13-.62.38-1.62.87-3.15A14 14 0 0 1 15.3 2.7l.06-.05a.44.44 0 0 1 .22-.09Z",
    fill: "#232323"
  }));
};
var _default = exports.default = dryscalphair;